import {
  LiveStreamCreateGiveawayItemRequestCriteriaEnum,
  UpcomingShowCreateGiveawayItemRequestCriteriaEnum,
} from '../../../generated/api';
import { assertNever } from '../../../utils/typeHelper';

export enum GiveawayCondition {
  Share = 'Share',
  Comment = 'Comment',
}

export function toLiveStreamCreateGiveawayItemRequestCriteriaEnum(
  condition: GiveawayCondition,
): LiveStreamCreateGiveawayItemRequestCriteriaEnum {
  switch (condition) {
    case GiveawayCondition.Share:
      return LiveStreamCreateGiveawayItemRequestCriteriaEnum.ShareToEnter;
    case GiveawayCondition.Comment:
      return LiveStreamCreateGiveawayItemRequestCriteriaEnum.CommentToEnter;
    default:
      assertNever(condition);
  }
}

export function fromLiveStreamCreateGiveawayItemRequestCriteriaEnum(
  condition: LiveStreamCreateGiveawayItemRequestCriteriaEnum,
): GiveawayCondition {
  switch (condition) {
    case LiveStreamCreateGiveawayItemRequestCriteriaEnum.ShareToEnter:
      return GiveawayCondition.Share;
    case LiveStreamCreateGiveawayItemRequestCriteriaEnum.CommentToEnter:
      return GiveawayCondition.Comment;
    default:
      assertNever(condition);
  }
}

export const toUpcomingShowCreateGiveawayItemRequestCriteriaEnum: (
  condition: GiveawayCondition,
) => UpcomingShowCreateGiveawayItemRequestCriteriaEnum = toLiveStreamCreateGiveawayItemRequestCriteriaEnum as any;

export const fromUpcomingShowCreateGiveawayItemRequestCriteriaEnum: (
  condition: UpcomingShowCreateGiveawayItemRequestCriteriaEnum,
) => GiveawayCondition = fromLiveStreamCreateGiveawayItemRequestCriteriaEnum as any;
